import { render, staticRenderFns } from "./shapeBro.vue?vue&type=template&id=e1729ac0&scoped=true"
import script from "./shapeBro.vue?vue&type=script&lang=js"
export * from "./shapeBro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1729ac0",
  null
  
)

export default component.exports